import { Component } from "react";
import { Modal, ModalBody } from "reactstrap";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormField from "../../../components/FormField/FormField";
import { connect } from "react-redux";
import ConfirmStaffInvitePaymentModal from "./confirm-staff-invite-payment-modal";
import UpgradeLock from "../../../components/UpgradeLock/UpgradeLock";
import { canUseOrganizationStaff } from "../../../utils/organizationStaffAccess";

const validation = Yup.object().shape({
  first_name: Yup.string().required("First Name is required."),
  last_name: Yup.string().required("Last Name is required."),
  email: Yup.string()
    .matches(
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
      "Please enter valid email"
    )
    .required("Email is required"),
});

let initialValues = {
  first_name: "",
  last_name: "",
  email: "",
};

class InviteUserModal extends Component {
  state = {
    isOpen: false,
    showPaymentConfirm: false,
    pendingInviteData: null,
  };

  toggle = () => {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
      pendingInviteData: null,
    }));
  };

  togglePaymentConfirm = () => {
    this.setState((prevState) => ({
      showPaymentConfirm: !prevState.showPaymentConfirm,
    }));
  };

  inviteUserBtnHandler = () => {
    this.setState({ isOpen: true });
  };

  handleFormSubmit = (data) => {
    this.setState({
      isOpen: false,
      pendingInviteData: data,
      showPaymentConfirm: true,
    });
  };

  handleConfirmPayment = (data) => {
    const { onInviteStaff } = this.props;
    this.setState({ pendingInviteData: null });
    onInviteStaff(data);
  };

  render() {
    const {
      isOpen,
      showPaymentConfirm,
      pendingInviteData,
    } = this.state;
    const { subscription } = this.props;
    const { userPlan } = subscription;
    const inviteAllowed = canUseOrganizationStaff(userPlan);
    const seatPrice =
      userPlan?.plan_period_type === "monthly"
        ? userPlan?.monthly_price
        : userPlan?.annual_price;

    return (
      <>
        <ConfirmStaffInvitePaymentModal
          isOpen={showPaymentConfirm}
          toggle={this.togglePaymentConfirm}
          inviteData={pendingInviteData}
          userPlan={userPlan}
          onConfirm={this.handleConfirmPayment}
        />

        <UpgradeLock locked={!inviteAllowed} inline>
          <button className="btn btn-app w-auto" onClick={this.inviteUserBtnHandler}>
            <span className="mr-2">+</span> Invite User
          </button>
        </UpgradeLock>

        <Modal isOpen={isOpen} toggle={this.toggle}>
          <ModalBody>
            <div className="">
              <div className="eventdetailsaddbox rd_modalvieew">
                <div className="box_content rd_modalboxcontent">
                  <div className="rd_inputselectheadermodalsetting">
                    <button className="rd_colsebtn" onClick={this.toggle}></button>
                  </div>
                  <h3 className="rd_modalheadertext rd_modalheadertextleft">
                    Invite new user
                  </h3>

                  <div
                    className="alert alert-info alert-dismissible fade show"
                    role="alert"
                  >
                    <strong>Payment required.</strong> Adding a staff member costs{" "}
                    <strong>${seatPrice}</strong> per{" "}
                    {userPlan?.plan_period_type === "monthly" ? "month" : "year"}{" "}
                    (prorated for the current billing period). You will confirm
                    payment before the invitation is sent.
                  </div>

                  <Formik
                    validationSchema={validation}
                    initialValues={initialValues}
                    enableReinitialize
                    onSubmit={this.handleFormSubmit}
                  >
                    {(formProps) => {
                      const {
                        values,
                        errors,
                        touched,
                        handleChange,
                      } = formProps;

                      return (
                        <Form>
                          <div className="rd_addnewuserfieth">
                            <label htmlFor="">First Name *</label>
                            <div className="input-group">
                              <FormField
                                type="text"
                                name="first_name"
                                elementclasses="p-2"
                                placeholder="Enter First Name"
                                value={values.first_name}
                                errors={errors}
                                touched={touched}
                                onChange={({ target }) => {
                                  const { value } = target;
                                  handleChange({
                                    target: { name: "first_name", value },
                                  });
                                }}
                              />
                            </div>

                            <label htmlFor="">Last Name *</label>
                            <div className="input-group">
                              <FormField
                                type="text"
                                name="last_name"
                                elementclasses="p-2"
                                placeholder="Enter Last Name"
                                value={values.last_name}
                                errors={errors}
                                touched={touched}
                                onChange={({ target }) => {
                                  const { value } = target;
                                  handleChange({
                                    target: { name: "last_name", value },
                                  });
                                }}
                              />
                            </div>

                            <label htmlFor="">Email *</label>
                            <div className="input-group">
                              <FormField
                                type="text"
                                name="email"
                                elementclasses="p-2"
                                placeholder="Enter Email"
                                value={values.email}
                                errors={errors}
                                touched={touched}
                                onChange={({ target }) => {
                                  const { value } = target;
                                  handleChange({
                                    target: { name: "email", value },
                                  });
                                }}
                              />
                            </div>
                          </div>

                          <div className="rd_cancelappbtnmodal">
                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={this.toggle}
                            >
                              Back
                            </button>
                            <button type="submit" className="btn btn-app">
                              Continue to Payment
                            </button>
                          </div>
                        </Form>
                      );
                    }}
                  </Formik>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  subscription: state.subscription,
});

export default connect(mapStateToProps, null)(InviteUserModal);
